// pages/Contact.jsx
import React, { useState } from "react";
import "./Contact.css";
import Header from "../../components/Header/Header";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Placeholder: Add your form submission logic (EmailJS / Firebase / API)
    console.log("Submitted:", formData);
    setSubmitted(true);
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <div>
        <Header />
    <section className="contact-section">
      <div className="contact-container">
        <h2 className="contact-title">Կապ հաստատել մեզ հետ</h2>
        <p className="contact-text">
          Ուղարկեք մեզ ձեր հարցերը կամ առաջարկները, և մենք շուտով կպատասխանենք։
        </p>

        {/* Contact Info */}
        <div className="contact-info">
          <p>📞 Հեռախոս: <a href="tel:+37455444855">+374 55 444855</a></p>
          <p>✉️ Էլ․ փոստ: <a href="mailto:info@brandbridge.am">info@brandbridge.am</a></p>
          <div className="contact-socials">
            <a href="https://www.instagram.com/pascali.evn/" target="_blank" rel="noopener noreferrer">
              <img src="/icons/instagram.png" alt="Instagram" />
            </a>
            <a href="https://www.facebook.com/profile.php?id=61575009515586" target="_blank" rel="noopener noreferrer">
              <img src="/icons/facebook.png" alt="Facebook" />
            </a>
            <a href="https://wa.me/37455444855" target="_blank" rel="noopener noreferrer">
              <img src="/icons/whatsapp.png" alt="WhatsApp" />
            </a>
          </div>
        </div>

        {/* Success Message */}
        {submitted && (
          <p className="contact-success">
            Ձեր հաղորդագրությունը հաջողությամբ ուղարկվեց։ Շնորհակալություն։
          </p>
        )}

        {/* Contact Form */}
        <form className="contact-form" onSubmit={handleSubmit}>
          <label>
            Անուն
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Էլ. Փոստ
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </label>

          <label>
            Հաղորդագրություն
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows="6"
            ></textarea>
          </label>

          <button type="submit" className="contact-button">
            Ուղարկել
          </button>
        </form>
      </div>
    </section>
   </div>

  );
}
